import { useState } from 'react';

export type useModalProps<DataType> = {
	defaultOpen?: boolean;
	initialData?: DataType;
};

const useModal = <DataType>({
	defaultOpen = false,
	initialData = undefined,
}: useModalProps<DataType>) => {
	const [isOpen, setIsOpen] = useState(defaultOpen);
	const [data, setData] = useState(initialData);

	const toggle = () => {
		setIsOpen(!open);
	};

	const open = (newData?: DataType) => {
		setIsOpen(true);
		if (newData) {
			setData(newData);
		}
	};

	const close = (newData?: DataType) => {
		setIsOpen(false);
		if (newData) {
			setData(newData);
		}
	};

	const reset = () => {
		setIsOpen(false);
		setData(initialData);
	};

	return {
		// Visibility
		isOpen,
		toggle,
		open,
		close,
		reset,
		// Data
		data,
		setData,
	};
};

export default useModal;
